/**
 * Solana Pay URL builder — native SOL transfers.
 *
 * Spec: https://docs.solanapay.com/spec
 * Format: solana:<recipient>?amount=<amount>[&reference=<ref>][&label=<label>]
 *
 * Native SOL only — no spl-token param, no mint address.
 */

export interface SolanaPayParams {
  /** Base58 wallet pubkey — native SOL deposit target */
  recipient: string;
  /** Decimal string, e.g. '10.000000000' (9 decimals for SOL) */
  amount: string;
  /** Optional — payment-session ID for reconciliation */
  reference?: string;
  /** Optional — tournament name shown in wallet UI */
  label?: string;
}

/**
 * Build a Solana Pay transfer URL for native SOL.
 *
 * @param params - recipient, amount (decimal string), optional reference and label
 * @returns Solana Pay URL string, e.g. "solana:recipient?amount=1.5&reference=123&label=Tournament"
 */
export function buildSolanaPayUrl(params: SolanaPayParams): string {
  const { recipient, amount, reference, label } = params;

  const query = new URLSearchParams();
  query.set('amount', amount);
  if (reference !== undefined && reference !== '') {
    query.set('reference', reference);
  }
  if (label !== undefined && label !== '') {
    query.set('label', label);
  }

  return `solana:${recipient}?${query.toString()}`;
}
